import {
    BOOKING_LIST,
    BOOKING_PAGINATION,
    BOOKING_SUMMARY,
    BOOKING_CANCEL_LIST,
    BOOKING_CANCEL_PAGINATION,
    BOOKING_CANCEL_SUMMARY
} from './constant';

export const initStateFeed = {
    bookingList: [],
    pagination: {},
    summary: {},
    cancelBookingList: [],
    cancelPagination: {},
    cancelSummary: {},
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case BOOKING_LIST: {
            return {
                ...state,
                bookingList: action.payload,
            };
        }
        case BOOKING_PAGINATION: {
            return {
                ...state,
                pagination: action.payload,
            };
        }
        case BOOKING_SUMMARY: {
            return {
                ...state,
                summary: action.payload,
            };
        }
        case BOOKING_CANCEL_LIST: {
            return {
                ...state,
                cancelBookingList: action.payload,
            };
        }
        case BOOKING_CANCEL_PAGINATION: {
            return {
                ...state,
                cancelPagination: action.payload,
            };
        }
        case BOOKING_CANCEL_SUMMARY: {
            return {
                ...state,
                cancelSummary: action.payload,
            };
        }
        default:
            return state;
    }
};
